var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',_vm._b({attrs:{"id":"page1"}},'canvas',_vm.canvasAttrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }